import clsx from "clsx";

export const container = clsx(
  "flex flex-col justify-center items-center overflow-no-scroll"
);
export const wrapper = clsx("flex flex-col lg:mt-10 relative");
export const image = clsx("w-auto mb-[2px] h-full");
export const caption = clsx(
  "lg:text-right text-center text-[10px] text-black/40"
);


